import alternativesJson from '../../../data/alternative-pages.json';
import {currentYear, replaceYearDeep} from '../replace-year';

export interface ComparisonRow {
  feature: string;
  us: string;
  them: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface AlternativeTool {
  slug: string;
  toolName: string;
  relatedSlugs: string[];
  quickVerdict: {bestForUs: string; bestForThem: string};
  metaTitle: string;
  metaDescription: string;
  h1: string;
  introParagraphs: string[];
  painPoints: {title: string; body: string}[];
  comparisonRows: ComparisonRow[];
  whyLinkInBio: {title: string; body: string}[];
  faq: FaqItem[];
  ctaLine: string;
}

const alternatives = replaceYearDeep(
  alternativesJson as unknown as Record<string, AlternativeTool>,
  currentYear(),
);

export function getAlternativeTool(slug?: string): AlternativeTool | null {
  if (!slug) return null;
  return alternatives[slug] || null;
}

export function getAllAlternativeTools(): AlternativeTool[] {
  return Object.values(alternatives);
}

export function getRelatedTools(tool: AlternativeTool): AlternativeTool[] {
  return tool.relatedSlugs
    .map(slug => alternatives[slug])
    .filter((t): t is AlternativeTool => !!t);
}
